import React, { useEffect, useState } from "react";
import VideoForm from "./Form";
import { Box, Grid, Divider } from "@mui/material";
import {useNavigate} from 'react-router-dom';
import IntroComponent from "./IntroComponent";
import IntroSection from "./IntroSection";
import {getYouTubeEmbedId} from "../utils/videoUtils";
import Features from "./FeaturesSection";
import HistoryBoard from "./HistoryBoard";
import { deleteNote, getAllSavedNotes } from "../../storage/LocalStorage";
import FaqSection from "./FaqSection";
import { Helmet } from 'react-helmet';
import { sendSubmitButtonGAEvent } from "../../analytics/GoogleAnalytics";
import { CTBox, StyledGrid } from "../style/StyledComponents";

const IntroVideoPage = () => {
    const [url, setUrl] = useState("");
    const navigate = useNavigate();
    const [previouslyWatchedVideos, setPreviouslyWatchedVideos] = useState([]);

    const handleSubmit = (e) => {
        const embedId = getYouTubeEmbedId(url)
        navigate(`/video/${embedId}`);
        sendSubmitButtonGAEvent(embedId);
    }

    const handleDeleteClickOnHistory = (id) => {
        deleteNote(id);
        const notes = getAllSavedNotes();
        const videos = [];
        if (notes) {
            for (const [key, value] of Object.entries(notes)) {
                const video = {}
                video.id = key;
                video.title = value.title;
                video.bookmark = value.bookmark;
                video.updateTime = value.updateTime;
                videos.push(video);
            }
        }
        videos.sort((a,b) => b.updateTime - a.updateTime);
        setPreviouslyWatchedVideos(videos);
    }

    const handleVideoClickOnHistory = (embedId) => {
        navigate(`/video/${embedId}`);
    }

    useEffect(() => {
        const notes = getAllSavedNotes();
        const videos = [];
        if (notes) {
            for (const [key, value] of Object.entries(notes)) {
            const video = {}
            video.id = key;
            video.title = value.title;
            video.updateTime = value.updateTime;
            videos.push(video);
            }
        }
        videos.sort((a,b) => b.updateTime - a.updateTime);
        setPreviouslyWatchedVideos(videos);
    }, []);

    return (
        <>
            <Helmet>
                <title>ClipThoughts | Video</title>
                <link rel="canonical" href="https://clipthoughts.com" />
            </Helmet>
            <CTBox>
                <IntroSection />
                <StyledGrid container padding={2}>
                    <VideoForm
                        url={url}
                        setUrl={setUrl}
                        handleSubmit={handleSubmit}
                    />
                </StyledGrid>
                
                <IntroComponent />
                <Divider flexItem />
                {previouslyWatchedVideos && previouslyWatchedVideos.length > 0 && <HistoryBoard 
                        videos={previouslyWatchedVideos}
                        handleDeleteClickOnHistory={handleDeleteClickOnHistory}
                        handleVideoClickOnHistory={handleVideoClickOnHistory}
                    />
                }
                { previouslyWatchedVideos && previouslyWatchedVideos.length > 0 && <Divider flexItem /> } 
                <Features />
                <Divider flexItem sx={{marginTop: "4px"}} />
                <FaqSection />
            </CTBox>
        </>
    );
}

export default IntroVideoPage;